(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('AlertsNewController', AlertsNewController);

    AlertsNewController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'Subscription'];

    function AlertsNewController($stateParams, $uibModalInstance, entity, Subscription) {
        var vm = this;
        vm.subscription = entity;
        vm.name = $stateParams.name;

        vm.clear = clear;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            console.log('saving');
            Subscription.save(vm.subscription, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
